export default {
  lazy: 'js-lazy',
  lightgallery: 'js-lightgallery',
  headerMeta: 'js-header-info',
  textarea: 'js-textarea',
  menu: {
    burger: 'js-burger',
    menu: 'js-menu',
  },
  slider: {
    container: 'js-slider',
    slider: {
      wrap: 'slider__wrap',
      prev: 'js-slider-prev',
      next: 'js-slider-next',
      slide: 'slide',
    },
    plugin: {
      container: 'tns-slider',
      activeSlide: 'tns-slide-active',
    },
  },
}
